<svelte:options runes={true} />

<script lang="ts">
  interface Props {
    /** The term Bloomreach corrected the typed query to. */
    query: string;
    class?: string;
  }

  let { query, class: className = "" }: Props = $props();
</script>

<!-- Sits above the listbox, never inside it: a listbox may contain options only
     (aria-required-children), and this is a status line, not something to arrow onto.
     role="status" so the correction is announced rather than silently applied. -->
<p class={["da-autocorrect-notice", className]} role="status">
  Showing results for <strong class="da-autocorrect-notice__term">{query}</strong>
</p>

<style>
  @layer aurora {
    .da-autocorrect-notice {
      margin: 0;
      font-family: var(--da-font-family-primary);
      font-size: var(--da-font-size-sm);
      color: var(--da-color-charcoal-400);
    }

    .da-autocorrect-notice__term {
      font-weight: var(--da-font-weight-semibold);
      color: var(--da-color-charcoal-500);
    }
  }
</style>
